module.exports = __webpack_public_path__ + "img/hoodie.f0ac41ab.svg";